export * from './qraft/index';

import { requestFn } from '@openapi-qraft/react';
import type {
  OperationSchema,
  RequestFnInfo,
  RequestFnOptions,
  RequestFnResponse,
} from '@openapi-qraft/tanstack-query-react-types';
import { MutationCache, QueryClient } from '@tanstack/react-query';
import { announceSaved, saveMessage } from '@/saveBanner';
import { createAPIClient } from './qraft/index';

export const queryClient = new QueryClient({
  // Every successful change confirms itself in the save banner.
  mutationCache: new MutationCache({
    onSuccess: (_data, _variables, _context, mutation) => {
      const title = saveMessage(mutation);
      if (title) announceSaved(title);
    },
  }),
});

export const API_ENDPOINT = import.meta.env.VITE_API_ENDPOINT || '/api';

function customRequestFn<TData, TError>(
  schema: OperationSchema,
  requestInfo: RequestFnInfo,
  options?: RequestFnOptions,
): Promise<RequestFnResponse<TData, TError>> {
  const newRequestInfo = {
    ...requestInfo,
    credentials: 'include',
  };
  return requestFn(schema, newRequestInfo as RequestFnInfo, options);
}

const apiClient = createAPIClient({
  baseUrl: API_ENDPOINT,
  requestFn: customRequestFn,
  queryClient,
});

export default apiClient.v3;
